import Highcharts from 'highcharts';

export const EPD_MATERIAL_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
    height: 320
  },
  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  colors: [
    '#003c4f',
    '#00747a',
    '#dcf600',
    '#01c9b3',
    '#b0c3c8',
    '#003133',
    '#5c6700',
    '#b0eee7',
    '#001921',
    '#b0d4d6',
    '#f4fcb0',
    '#00544b',
    '#002b38',
    '#54a2a6',
    '#e8f954',
    '#018f7f',
    '#018f7f',
    '#547c89',
    '#005257',
    '#9caf00',
    '#55dbcc'
  ],
  plotOptions: {
    pie: {
      shadow: false,
      innerSize: '80%',
      borderWidth: 4,
      showInLegend: true,
      dataLabels: {
        enabled: true,
        distance: 10,
        format: '{point.name}: {point.y:.1f} %'
      }
    },
    series: {
      point: {
        events: {}
      },
      events: {},
      states: {
        inactive: {
          opacity: 1
        },
        hover: {
          enabled: true
        }
      },
      animation: false
    }
  },
  legend: {
    symbolHeight: 10,
    symbolWidth: 10,
    symbolPadding: 4,
    symbolRadius: 0,
    layout: 'horizontal',
    align: 'right',
    verticalAlign: 'bottom'
  },
  series: [
    {
      type: 'pie',
      name: '',
      data: []
    }
  ]
};

export const EPD_CLIMATE_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    type: 'column',
    height: 300
  },
  title: {
    text: null
  },
  credits: {
    enabled: false
  },
  colors: ['#003C4F', '#547080', '#339095', '#FFA76B'],
  xAxis: {
    categories: []
  },
  yAxis: {
    min: 0,
    title: {
      text: ''
    }
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: true // Enable data labels
      }
    }
  },
  legend: {
    enabled: false
  },
  series: []
};
